import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useOverflowFlyoutStyles = makeStyles({
    root: {},
    menu: {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        height: "100vh"
    },
    appList: {
        maxHeight: "500px",
        overflowY: "auto",
        display: "flex",
        flexWrap: "wrap",
        width: "90%",
        alignContent: "flex-start",
        ...shorthands.padding("16px")
    },
    footer: {
        bottom: 0,
        height: "64px",
        display: "flex",
        justifyContent: "flex-end",
        alignContent: "center",
        width: "90%",
        ...shorthands.borderTop("1px", "solid", themeTokens.colorNeutralStroke1),
        ...shorthands.margin(0, "12px")
    },
    button: {
        ...shorthands.margin("16px", 0, "12px", 0)
    },
    input: {
        backgroundColor: themeTokens.colorNeutralBackground3,
        width: "90%",
        marginTop: "16px",
        ...shorthands.border(0),
        color: themeTokens.colorNeutralForeground2
    },
    popover: {},
    menuitem: {}
});
